import { FileText, Settings, Users, Zap } from "lucide-react";
import { SamplePrompt, TemplateType, WhatsAppTemplate } from "../../components/types";

  export const templateTypes: TemplateType[] = [
    { id: "marketing", label: "Marketing", icon: Zap, color: "emerald" },
    {
      id: "transactional",
      label: "Transactional",
      icon: FileText,
      color: "blue",
    },
    {
      id: "authentication",
      label: "Authentication",
      icon: Settings,
      color: "purple",
    },
    { id: "utility", label: "Utility", icon: Users, color: "orange" },
  ];

  export const samplePrompts: SamplePrompt[] = [
    {
      id: 1,
      text: "Create a welcome message for new customers with a 20% discount offer",
    },
    {
      id: 2,
      text: "Generate an order confirmation template with tracking details",
    },
    { id: 3, text: "Design an appointment reminder for healthcare clinic" },
    { id: 4, text: "Create a shipping notification with delivery tracking" },
    { id: 5, text: "Generate a payment reminder for overdue invoices" },
  ];

  // Existing templates mock data
  export const existingTemplates: WhatsAppTemplate[] = [
    {
      id: 1,
      name: "welcome_new_customer",
      category: "MARKETING",
      status: "APPROVED",
      language: "en",
      createdAt: "2024-07-15",
      usage: 1250,
      header: { type: "TEXT", text: "🎉 Welcome to {{1}}!" },
      body: {
        text: "Hi {{1}}! Welcome to our family. Get 20% OFF your first order with code WELCOME20!",
      },
      buttons: [{ type: "URL", text: "Shop Now", url: "https://{{1}}/shop" }],
    },
    {
      id: 2,
      name: "order_confirmation",
      category: "TRANSACTIONAL",
      status: "APPROVED",
      language: "en",
      createdAt: "2024-07-10",
      usage: 3420,
      header: { type: "TEXT", text: "📦 Order Confirmed" },
      body: {
        text: "Hi {{1}}, your order #{{2}} has been confirmed! Track your package: {{3}}",
      },
      buttons: [
        { type: "URL", text: "Track Order", url: "https://{{1}}/track/{{3}}" },
      ],
    },
    {
      id: 3,
      name: "appointment_reminder",
      category: "UTILITY",
      status: "APPROVED",
      language: "en",
      createdAt: "2024-07-08",
      usage: 850,
      header: { type: "TEXT", text: "📅 Appointment Reminder" },
      body: {
        text: "Hi {{1}}, this is a reminder for your appointment on {{2}} at {{3}}. Please arrive 15 minutes early.",
      },
      buttons: [
        {
          type: "PHONE_NUMBER",
          text: "Call Clinic",
          phone_number: "+1234567890",
        },
      ],
    },
    {
      id: 4,
      name: "shipping_notification",
      category: "TRANSACTIONAL",
      status: "PENDING",
      language: "en",
      createdAt: "2024-07-18",
      usage: 0,
      header: { type: "TEXT", text: "🚚 Your Order is On Its Way!" },
      body: {
        text: "Great news {{1}}! Your order #{{2}} has shipped and will arrive by {{3}}.",
      },
      buttons: [
        { type: "URL", text: "Track Package", url: "https://{{1}}/track" },
      ],
    },
    {
      id: 5,
      name: "payment_reminder",
      category: "UTILITY",
      status: "REJECTED",
      language: "en",
      createdAt: "2024-07-12",
      usage: 0,
      header: { type: "TEXT", text: "💳 Payment Reminder" },
      body: {
        text: "Hi {{1}}, your invoice #{{2}} of ${{3}} is overdue. Please make payment to avoid service interruption.",
      },
      buttons: [
        { type: "URL", text: "Pay Now", url: "https://{{1}}/pay/{{2}}" },
      ],
    },
    {
      id: 6,
      name: "otp_verification",
      category: "AUTHENTICATION",
      status: "APPROVED",
      language: "en",
      createdAt: "2024-07-14",
      usage: 5680,
      header: { type: "TEXT", text: "🔐 Verification Code" },
      body: {
        text: "Your OTP for {{1}} is: {{2}}. This code expires in 10 minutes. Do not share this code with anyone.",
      },
      footer: { text: "This is an automated message" },
    },
  ];